import { render, staticRenderFns } from "./LensBenchmarkCard.vue?vue&type=template&id=7956a6e8"
import script from "./LensBenchmarkCard.vue?vue&type=script&lang=js"
export * from "./LensBenchmarkCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports